<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="medialist" label="媒体管理"></TabPane>
            <TabPane name="adslist" label="投放位管理"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <keep-alive max="5">
          <router-view />
        </keep-alive>
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'mediaadslayout',
  methods: {
    changeRouter(name) {
      this.$router.push({ name })
    },
    getCurrent() {
      const hasAllAccess = ['M20874'].every((ret) => this.access.includes(ret))
      this.currentRoute = this.$route.name
      console.log(this.currentRoute)
      if (hasAllAccess && this.currentRoute === 'mediaads') this.changeRouter('medialist')
      else if (this.currentRoute === 'mediaads') this.changeRouter('noauth')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
<style lang="scss" scoped>
.c-content {
  height: calc(100% - 40px);
  position: relative;
}

::v-deep .ivu-poptip-rel {
  width: inherit;
}

/* 单选框覆盖 */
::v-deep .ivu-radio-wrapper {
  min-width: 94px;
  text-align: center;
  user-select: none;
}

::v-deep .ivu-checkbox-wrapper {
  .ivu-checkbox {
    margin-right: 10px;
  }
}

/* 表单选项 */
::v-deep .row-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 32px;

  .col-item {
    text-align: right;
  }

  i {
    margin-right: 4px;
    vertical-align: middle;

    &.ivu-icon-md-add {
      margin: 0;
    }
  }

  .item-field {
    font-size: 14px;
    padding-right: 12px;
  }

  /* 必填项 */
  .row-item-must {
    position: relative;
    z-index: 5;

    &:after {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 4px;
      position: absolute;
      top: 6px;
      right: 0;
      background-color: #f45858;
      border-radius: 3px;
    }
  }
}

/* tags 超长处理 */
::v-deep .ivu-tag {
  .ivu-icon-ios-close {
    top: 3px;
    float: right;
  }

  .ivu-tag-text {
    width: 80%;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

::v-deep .ivu-tabs-mini {
  .ivu-tabs-bar {
    margin-bottom: 0;
  }

  .ivu-tabs-tab {
    padding: 8px;
  }
}
</style>
